import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetAverage } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {

    const Authorization = UserToken;
    const url = ApiUrl5 + 'response-and-resolve-time-rate';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    var data2 = fromJS({});
    if (response.ok) {
        data = fromJS(await response.json());
        data2 = data.get("response")
        data = data.get("resolve")

        var x = []
        for (var i = 0; i < data.size; i++) {
            var datinti = data.get(i)
            var datinti2 = data2.get(i)
            var obj = { name: datinti.get("tanggal") }
            obj["response"] = parseInt(datinti2.get("average"))
            obj["resolve"] = parseInt(datinti.get("average"))
            x.push(obj)

        }
        data = x
    }
    dispatch({ type: GetAverage, data: fromJS(data) });
    return data
};

